import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8e7b116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-inline-block" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner" }, null, -1))

import { withDefaults } from 'vue';

// Define props
interface Props {
  spinner_text?: string;
  class_custom?: string;
}

// Set default values for props

export default /*#__PURE__*/_defineComponent({
  __name: 'SpinningLoaderInline',
  props: {
    spinner_text: { default: 'Loading...' },
    class_custom: { default: '' }
  },
  setup(__props: any) {

// Component imports


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        class: _normalizeClass(["spinner-text", __props.class_custom])
      }, _toDisplayString(__props.spinner_text), 3)
    ])
  ]))
}
}

})